"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAN_KEYS = exports.CHECKOUT_PLANS = void 0;
const services_1 = __importDefault(require("./services"));
const request_1 = __importDefault(require("./utils/request"));
class SDK {
    constructor(sdkConfig) {
        this.sdkConfig = sdkConfig;
        this.defaultVersion = 'v3';
        this.httpClient = (0, request_1.default)(sdkConfig.realm, this.getToken.bind(this), sdkConfig.progress);
        this.admin = services_1.default.admin(this);
        this.auth = services_1.default.auth(this);
        this.billing = services_1.default.billing(this);
        this.collection = services_1.default.collection(this);
        this.configuration = services_1.default.configuration(this);
        this.course = services_1.default.course(this);
        this.conversation = services_1.default.conversation(this);
        this.document = services_1.default.document(this);
        this.email = services_1.default.email(this);
        this.lernsets = services_1.default.lernsets(this);
        this.mindItem = services_1.default.mindItem(this);
        this.notification = services_1.default.notification(this);
        this.product = services_1.default.product(this);
        this.school = services_1.default.school(this);
        this.search = services_1.default.search(this);
        this.registration = services_1.default.registration(this);
        this.text = services_1.default.text(this);
        this.track = services_1.default.track(this);
        this.user = services_1.default.user(this);
        this.ai = services_1.default.ai(this);
    }
    getToken() {
        if (!this.sdkConfig.tokenProvider) {
            throw new Error('Authenticated endpoint: Must define a token provider');
        }
        const tokenType = this.sdkConfig.tokenProvider.type || 'token';
        const token = this.sdkConfig.tokenProvider.getToken();
        return `${tokenType} ${token}`;
    }
}
exports.default = SDK;
// Plan-key catalogue (SM-325). Exported so consumers can derive their own
// validation allow-lists from the runtime tuples instead of re-declaring them.
var billing_1 = require("./constants/billing");
Object.defineProperty(exports, "CHECKOUT_PLANS", { enumerable: true, get: function () { return billing_1.CHECKOUT_PLANS; } });
Object.defineProperty(exports, "PLAN_KEYS", { enumerable: true, get: function () { return billing_1.PLAN_KEYS; } });
